module.exports = __webpack_public_path__ + "static/media/compare.716952fd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/compare.png
// module id = 575
// module chunks = 0